export const ROUTES = {
  MODELS: '/models',
  DEPLOYMENTS: '/deployments',
  BATCH_SCORING: '/jobs',
};

export const ENDPOINTS = {
  storage: '/storage',
  ingest: '/ingest',
  deployment: '/deployer',
  deploymentServer: '/deploymentServer',
};

/**
 * Used in the admin URL to pass workspace and deployment IDs in a single path segment.
 */
export const WORKSPACE_DEPLOYMENT_ID_SEPARATOR = '.';
